var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoArrowRightSmall = function SvgIcoArrowRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    fill: "none",
    viewBox: "0 0 16 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "m11.704 11.41-.046-.058-4.335-5.076A.787.787 0 0 0 6.126 7.3l4.044 4.735-4.086 4.784A.787.787 0 1 0 7.28 17.84l4.53-5.304a.787.787 0 0 0-.107-1.127",
    clipRule: "evenodd"
  })));
};
export default SvgIcoArrowRightSmall;